import {fetchData} from "../../utils/common";

const getPrice = ({state, form}) => {
  const URL = `/basket/price`;

  form.addEventListener(`click`, async (evt) => {
    if (evt.target.classList.contains(`js-select-item`)) {
      const input = evt.target.closest(`.js-select`).querySelector(`.js-select-h-input`);

      state.current[input.name] = input.value;

      const price = await fetchData(URL, state);
      document.querySelector(`.js-price`).textContent = price;
    }
  });
};

export default getPrice;
